"use strict";
var largeImg = document.querySelector("#largeImg");
var thumbs = document.querySelector("#thumbs");
thumbs.addEventListener("click", function(e) {
    var link = e.target.closest("a");
    if (!link || !thumbs.contains(link)) return;
    e.preventDefault();
    largeImg.src = link.href;
    largeImg.alt = link.title;
});

//# sourceMappingURL=index.afe9dff5.js.map
